import angular from 'angular';

angular
  .module('rebroadcast', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('rebroadcast', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
